import React from 'react';

import { defaultTheme } from '@repo/styles';
import cn from 'classnames';

import { IConDefaultType } from '..';

export enum RocketIconVariant {
  DEFAULT = 'default',
}

interface IRocketIconProps extends IConDefaultType {
  variant?: RocketIconVariant;
}

function RocketIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = RocketIconVariant.DEFAULT,
}: IRocketIconProps) {
  const fill = color || defaultTheme.color.main;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === RocketIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M10.9374 5.1287H5.56501C5.14794 5.1287 4.73891 5.2979 4.44367 5.59314L3.35405 6.68276C2.89807 7.13874 2.89807 7.87685 3.35405 8.33283L5.61069 10.5895L5.24819 12.402C5.14371 12.9222 5.30698 13.4599 5.68302 13.8342L6.56453 14.7157C5.62169 14.6074 4.63274 14.8849 3.93947 15.5761C2.5766 16.9389 3.13917 18.4498 3.00805 19.9371C3.00805 20.5208 3.48222 20.9945 4.06552 20.9945C5.53075 20.866 7.07592 21.4129 8.42313 20.0652C9.06777 19.4219 9.43619 18.5349 9.31818 17.4698L10.1684 18.32C10.5376 18.6888 11.0681 18.8606 11.6019 18.7548L13.4131 18.3923L15.6698 20.6485C16.1253 21.1045 16.8634 21.1049 17.3198 20.6485L18.4094 19.5593C18.7047 19.2641 18.8739 18.8551 18.8739 18.4376V13.0656C20.6293 10.6487 22.0611 6.16756 19.9479 4.05431C17.8342 1.94064 13.3518 3.37415 10.9369 5.12828L10.9374 5.1287ZM7.67614 19.3178C6.73161 20.2624 5.67625 19.8271 4.06594 19.9375C4.17549 18.3471 3.72966 17.282 4.68773 16.3239C5.51256 15.5016 6.85131 15.5004 7.67614 16.3273C8.50266 17.1517 8.50308 18.493 7.67614 19.3178ZM4.10189 7.4306L5.19151 6.34098C5.29091 6.242 5.42542 6.18659 5.56543 6.18617H9.67518C8.99205 6.85534 7.15967 8.69576 6.18468 9.66863L4.10189 7.58541V7.4306ZM11.3946 17.7181C11.2182 17.7562 11.0427 17.6986 10.9166 17.5726L6.43086 13.0864C6.30481 12.9603 6.25025 12.7818 6.28535 12.6092L6.50996 11.4883L12.5155 17.4939L11.395 17.7181H11.3946ZM17.8173 18.438C17.8173 18.5776 17.7602 18.7138 17.6625 18.8119L16.5728 19.9011H16.418L14.3348 17.8183C15.2624 16.889 17.1557 15.0029 17.8173 14.3278V18.438ZM16.9899 13.668L13.5874 17.0709L6.93253 10.416L10.3355 7.01353C12.524 4.825 17.3507 2.95201 19.2009 4.80258C21.1255 6.72675 19.0993 11.5594 16.9899 13.6684V13.668ZM14.1161 7.24364C12.6577 7.24364 11.4725 8.42927 11.4725 9.88731C11.4725 11.3454 12.6577 12.531 14.1161 12.531C15.5746 12.531 16.7598 11.3458 16.7598 9.88731C16.7598 8.42885 15.5742 7.24364 14.1161 7.24364ZM14.1161 11.4735C13.2414 11.4735 12.5299 10.7621 12.5299 9.88731C12.5299 9.01257 13.2414 8.30111 14.1161 8.30111C14.9909 8.30111 15.7023 9.01257 15.7023 9.88731C15.7023 10.7621 14.9909 11.4735 14.1161 11.4735Z"
            fill={fill}
            stroke={fill}
            strokeWidth="0.5"
          />
        </svg>
      )}
    </i>
  );
}

export default RocketIcon;
